import { Component, OnInit } from '@angular/core';
import { PayLoadData } from 'src/Shared/model/PayLoadData';
import { isNullOrUndefined } from 'util';
import { VisitingCardRequest } from 'src/Shared/model/VisitingCardRequest';
import { DecryptionService } from 'src/shared/services/decryption.service';
import { Router, ActivatedRoute } from '@angular/router';
import { VisitingCardResponse } from 'src/Shared/model/VisitingCardResponse';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.css']
})
export class ShowComponent implements OnInit {
  Data: string;
  VisitingRequest: VisitingCardRequest;
  payload: PayLoadData;
  checkboxFlag: boolean = false;
  isLoading: boolean = false;
  isCanAprrove: boolean = false;
  No_Card :number;

  constructor(
    public decryptionServiceService: DecryptionService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.No_Card=  environment.No_Card;
    this.Data = sessionStorage.getItem('data');
    this.payload = JSON.parse(this.Data);
    if (!isNullOrUndefined(this.payload.employeeNo)  && this.payload.employeeNo != '') {
      if (this.payload.position >=this.payload.approvePosition)
       {
        this.isCanAprrove = true;
      }
      if(this.payload.is_Submited=="1")
      {
        this.router.navigate(['/thankyou']);
      }
    }
    else {
      this.router.navigate(['/unauthorize']);
    }


  }
  saveRequest() {
    this.isLoading = true;
    debugger;
    if (!isNullOrUndefined(this.Data)) {
      this.VisitingRequest = { EmployeeNo: this.payload.employeeNo,City:this.payload.city,Pincode:this.payload.pincode,No_Card:this.No_Card ,Address:this.payload.location};
      this.decryptionServiceService.SaveRequest(this.VisitingRequest).subscribe((data: VisitingCardResponse) => {
       debugger;
        if (data.response.toUpperCase() == 'SUCCESS') {
          this.payload.request = "now";
          this.payload.is_Submited ="1";
          this.Data = JSON.stringify(this.payload);
          sessionStorage.removeItem('data');
          sessionStorage.setItem('data',this.Data);
          this.router.navigate(['/thankyou']);
        } else {
          this.router.navigate(['/unauthorize']);
        }
      });
    }
    else {
      this.router.navigate(['/unauthorize']);
    }
    this.isLoading = false;
  }
}
